export default __webpack_public_path__ + "static/media/index.d.fc289809.ts";